var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedical(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "current",
    stroke: "current",
    width: "100%",
    height: "100%",
    viewBox: "0 0 400 400",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.41421
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.16667,0,0,3.16667,-2.16667,-2.16667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,1C29.3,1 1,29.3 1,64C1,98.7 29.3,127 64,127C98.7,127 127,98.7 127,64C127,29.3 98.7,1 64,1ZM64,119C33.7,119 9,94.3 9,64C9,33.7 33.7,9 64,9C94.3,9 119,33.7 119,64C119,94.3 94.3,119 64,119Z",
    style: {
      fillRule: "nonzero"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.15876,0,0,1,-32.4108,-4.49979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,110.373C212,106.856 209.536,104 206.5,104L195.5,104C192.464,104 190,106.856 190,110.373L190,299.627C190,303.144 192.464,306 195.5,306L206.5,306C209.536,306 212,303.144 212,299.627L212,110.373Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(7.09536e-17,-1.15876,1,6.12323e-17,-4.49979,433.411)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212,110.373C212,106.856 209.536,104 206.5,104L195.5,104C192.464,104 190,106.856 190,110.373L190,299.627C190,303.144 192.464,306 195.5,306L206.5,306C209.536,306 212,303.144 212,299.627L212,110.373Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedical);
export default __webpack_public_path__ + "static/media/medical.b06c20d48d65f224ee1e0bb1898d189f.svg";
export { ForwardRef as ReactComponent };